var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 10.5003C1.66663 5.89795 5.39758 2.16699 9.99996 2.16699C14.6023 2.16699 18.3333 5.89795 18.3333 10.5003C18.3333 15.1027 14.6023 18.8337 9.99996 18.8337H1.66663L4.1074 16.3929C2.59937 14.8848 1.66663 12.8015 1.66663 10.5003ZM5.69032 17.167H9.99996C13.6819 17.167 16.6666 14.1822 16.6666 10.5003C16.6666 6.81843 13.6819 3.83366 9.99996 3.83366C6.31806 3.83366 3.33329 6.81843 3.33329 10.5003C3.33329 12.294 4.04266 13.9711 5.28592 15.2144L6.46443 16.3929L5.69032 17.167ZM9.16663 5.50033H10.8333V15.5003H9.16663V5.50033ZM5.83329 8.00033H7.49996V13.0003H5.83329V8.00033ZM12.5 8.00033H14.1666V13.0003H12.5V8.00033Z",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageChatIcon);
export default __webpack_public_path__ + "static/media/message-chat-icon.fa9be2e4883d954a996039ae2f68def9.svg";
export { ForwardRef as ReactComponent };